import type { TrackDef } from '../track';
import { autoGates } from './util';

/**
 * Côte Varoise: tribute to round 4, Le Castellet (design.md A5.4).
 * A very long top straight, a hairpin at the bottom right, a tight loop,
 * then the infield back across at diagonal angles. Grass run-off.
 */
const centerline: [number, number][] = [
  [8, 0.8], [62, 0.8], [65, 2.5], [68.5, 6], [68.5, 24], [67, 26], [63, 26.5], [60.5, 24.5],
  [60, 18], [61.5, 16], [61.5, 10.5], [60, 8.7], [58, 9.2], [56.5, 11], [53, 12.6], [41, 13],
  [39, 14], [38.5, 17.5], [35, 18.5], [30, 17.5], [22, 15], [13, 12], [6, 10.5], [3, 9],
  [3, 7.5], [5, 6.2], [6.5, 4], [6.5, 2],
];

export const COTE_VAROISE: TrackDef = {
  id: 'cote-varoise',
  name: 'COTE VAROISE',
  subtitle: 'Tribute to Le Castellet',
  country: 'FRANCE',
  theme: 'forest',
  scale: 44.1,
  offset: [5, 5],
  centerline,
  roadWidth: 72,
  kerbWidth: 6,
  runoffWidth: 22,
  runoffSurface: 'grass',
  gates: autoGates(centerline, 0, 0.3, 6),
  carparks: [],
  raceLaps: 3,
  defaultRecord: 30,
};
